export default __webpack_public_path__ + "static/media/indian.264c9bd9.png";